import { func, object, string } from 'prop-types';
import { path } from 'ramda';
import React from 'react';
// import { Slider } from 'material-ui';
import { Col, Row } from 'react-flexbox-grid';

import ContentColumns from '../components/ContentColumns';
import Slider from 'components/Slider';
import { colors } from 'styles/provider';
import TextFieldArea from 'components/TextFieldArea';
import RadioButtonGroup from 'components/RadioButtonGroup';
import exists from 'lib/exists';

const stepLabelStyle = {
  width: '2rem',
  textAlign: 'center',
};

const QuestionSlider = ({ fieldName, questionLocale }, { fm, formValues, onChange }) => {
  const onChangeValueSlider = fieldName => value => {
    onChange({ [fieldName]: value });
  };
  return (
    <div>
      <h3>{fm(questionLocale)}</h3>
      <br />
      <Row between="xs">
        <Col xs={12} style={{ padding: '0 1rem' }}>
          <Slider
            min={-5}
            max={5}
            trackColor={colors.clrSecondary}
            handleColor={colors.clrSecondary}
            value={path(['rehab8', fieldName], formValues)}
            onChange={onChangeValueSlider(fieldName)}
            dots
            styleOverride={{ height: '2rem' }}
          />
        </Col>

        <Col style={stepLabelStyle}>-5</Col>
        <Col style={stepLabelStyle}>-4</Col>
        <Col style={stepLabelStyle}>-3</Col>
        <Col style={stepLabelStyle}>-2</Col>
        <Col style={stepLabelStyle}>-1</Col>
        <Col style={stepLabelStyle}>0</Col>
        <Col style={stepLabelStyle}>1</Col>
        <Col style={stepLabelStyle}>2</Col>
        <Col style={stepLabelStyle}>3</Col>
        <Col style={stepLabelStyle}>4</Col>
        <Col style={stepLabelStyle}>5</Col>
      </Row>
      <br />
      <Row between="xs" style={{ marginTop: '-1rem', color: colors.clrLabelLight, padding: '0 0.5rem' }}>
        <Col>{fm('onlineRehabilitation.rehab8.slider.significantlyWorse')}</Col>
        <Col>
          {fieldName === 'rehabilitationBenefit'
            ? fm('onlineRehabilitation.rehab8.slider.noEffect')
            : fm('onlineRehabilitation.rehab8.slider.normal')}
        </Col>
        <Col>{fm('onlineRehabilitation.rehab8.slider.significantlyBetter')}</Col>
      </Row>
    </div>
  );
};

QuestionSlider.propTypes = {
  fieldName: string,
  questionLocale: string,
};

QuestionSlider.contextTypes = {
  fm: func,
  formValues: object,
  onChange: func,
};

const View3 = (_, { fm, formValues, onChange, fmString }) => {
  const onChangeValue = (fieldName, type) => value => {
    if (type === 'text') {
      const valueText = value.currentTarget.value;
      exists(valueText) && onChange({ [fieldName]: valueText });
    } else {
      onChange({ [fieldName]: value });
    }
  };

  // Set slider fields automatically to 0 if undefined
  React.useEffect(() => {
    let onChangeObject = {};
    const sliderFields = ['fatigueBenefit', 'cognitionBenefit', 'studyingWorkingNow', 'rehabilitationBenefit'];
    sliderFields.forEach(field => {
      const value = path(['rehab8', field], formValues);
      if (!exists(value)) {
        onChangeObject = { ...onChangeObject, [field]: 0 };
      }
    });
    if (Object.keys(onChangeObject).length > 0) {
      onChange(onChangeObject);
    }
  }, []);

  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fm('onlineRehabilitation.rehab8.7.header')}</h2>
            <br />
            <div>{fm('onlineRehabilitation.rehab8.7.text')}</div>
            <br />
            <br />
            <QuestionSlider fieldName="fatigueBenefit" questionLocale="onlineRehabilitation.rehab8.7.fatigueBenefit" />
            <br />
            <br />
            <br />
            <QuestionSlider
              fieldName="cognitionBenefit"
              questionLocale="onlineRehabilitation.rehab8.7.cognitionBenefit"
            />
            <br />
            <br />
            <br />
            <QuestionSlider
              fieldName="studyingWorkingNow"
              questionLocale="onlineRehabilitation.rehab8.7.studyingWorkingNow"
            />
            <br />
            <br />
            <br />
            <QuestionSlider
              fieldName="rehabilitationBenefit"
              questionLocale="onlineRehabilitation.rehab8.7.rehabilitationBenefit"
            />
            <br />
            <div style={{ paddingLeft: '2rem' }}>
              <h3>{fm('onlineRehabilitation.rehab8.7.rehabExperiences')}</h3>
              <TextFieldArea
                editing
                input={{
                  value: path(['rehab8', 'rehabExperiences'], formValues) || '',
                  onChange: onChangeValue('rehabExperiences', 'text'),
                  name: '',
                }}
                placeholder={fmString('onlineRehabilitation.rehab8.7.rehabExperiencesPlaceholder')}
                rows={4}
                style={{ width: '100%' }}
              />
            </div>
            <br />
            <br />
            <br />
            <h3>{fm('onlineRehabilitation.rehab8.7.rehabFatigueCognitionBenefit')}</h3>
            <RadioButtonGroup
              editing
              input={{
                value: path(['rehab8', 'rehabFatigueCognitionBenefit'], formValues) || '',
                onChange: onChangeValue('rehabFatigueCognitionBenefit'),
                name: '',
              }}
              style={{ width: '100%' }}
              formatMessage={fm}
              options={[{ value: 'yes' }, { value: 'no' }, { value: 'cannotSay' }]}
              localeMessage={value => fm(`onlineRehabilitation.rehab8.${value}`)}
            />
            <br />
            <div style={{ paddingLeft: '2rem' }}>
              <h3>{fm('onlineRehabilitation.rehab8.7.rehabFatigueCognitionBenefitDetails')}</h3>
              <TextFieldArea
                editing
                input={{
                  value: path(['rehab8', 'rehabFatigueCognitionBenefitDetails'], formValues) || '',
                  onChange: onChangeValue('rehabFatigueCognitionBenefitDetails', 'text'),
                  name: '',
                }}
                placeholder={fmString('onlineRehabilitation.rehab8.7.rehabFatigueCognitionBenefitDetailsPlaceholder')}
                rows={4}
                style={{ width: '100%' }}
              />
            </div>
            <br />
            <br />
            <br />
            <h3>{fm('onlineRehabilitation.rehab8.7.rehabTechnicalFunctioning')}</h3>
            <RadioButtonGroup
              editing
              input={{
                value: path(['rehab8', 'rehabTechnicalFunctioning'], formValues) || '',
                onChange: onChangeValue('rehabTechnicalFunctioning'),
                name: '',
              }}
              style={{ width: '100%' }}
              formatMessage={fm}
              options={[{ value: 'yes' }, { value: 'no' }, { value: 'cannotSay' }]}
              localeMessage={value => fm(`onlineRehabilitation.rehab8.${value}`)}
            />
            <br />
            <div style={{ paddingLeft: '2rem' }}>
              <h3>{fm('onlineRehabilitation.rehab8.7.rehabTechnicalFunctioningDetails')}</h3>
              <TextFieldArea
                editing
                input={{
                  value: path(['rehab8', 'rehabTechnicalFunctioningDetails'], formValues) || '',
                  onChange: onChangeValue('rehabTechnicalFunctioningDetails', 'text'),
                  name: '',
                }}
                placeholder={fmString('onlineRehabilitation.rehab8.7.rehabTechnicalFunctioningDetailsPlaceholder')}
                rows={4}
                style={{ width: '100%' }}
              />
            </div>
            <br />
            <br />
            <br />
            <h3>{fm('onlineRehabilitation.rehab8.7.improvementSuggestions')}</h3>
            <TextFieldArea
              editing
              input={{
                value: path(['rehab8', 'improvementSuggestions'], formValues) || '',
                onChange: onChangeValue('improvementSuggestions', 'text'),
                name: '',
              }}
              placeholder={fmString('onlineRehabilitation.rehab8.7.improvementSuggestionsPlaceholder')}
              rows={4}
              style={{ width: '100%' }}
            />
            <br />
            <br />
            <br />
            <h3>{fm('onlineRehabilitation.rehab8.7.otherComments')}</h3>
            <TextFieldArea
              editing
              input={{
                value: path(['rehab8', 'otherComments'], formValues) || '',
                onChange: onChangeValue('otherComments', 'text'),
                name: '',
              }}
              placeholder={fmString('onlineRehabilitation.rehab8.7.otherCommentsPlaceholder')}
              rows={4}
              style={{ width: '100%' }}
            />
          </div>
        }
      />
    </React.Fragment>
  );
};

View3.contextTypes = {
  fm: func,
  formValues: object,
  onChange: func,
  fmString: func,
};

export default View3;
